import { dataBook } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBook = /*#__PURE__*/createIcon(dataBook)
export default IconBook
